/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { WorkspaceModel } from '../models';
import { CentralDatabaseKeys } from './central-database-keys';
import { AppVariables } from '@shared';

export const centralSchema: RxJsonSchema<WorkspaceModel> = {
	version: 3,
	primaryKey: CentralDatabaseKeys.workFileId,
	properties: {
		[CentralDatabaseKeys.workFileId]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[CentralDatabaseKeys.workspaceName]: {
			type: 'string'
		},
		[CentralDatabaseKeys.projects]: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					project_name: {
						type: 'string'
					},
					uofm_code: {
						type: ['string', 'number', 'null']
					},
					project_number: {
						type: 'string'
					},
					default_grid_type_code: {
						type: ['string', 'number', 'null']
					}
				}
			}
		},
		[CentralDatabaseKeys.fusionConfigHeaders]: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					fusionID: {
						type: 'string'
					},
					active_business_unit: {
						type: 'string'
					},
					active_logging_style: {
						type: 'string'
					},
					active_sstn_logging_style: {
						type: 'string'
					},
					userID: {
						type: 'string'
					},
					first_name: {
						type: 'string'
					},
					export_date: {
						type: 'string'
					},
					fusion_version: {
						type: 'string'
					},
					device_id: {
						type: 'string'
					},
					registration_token: {
						type: 'string'
					}
				}
			}
		},
		[CentralDatabaseKeys.fusionUsers]: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					userid: {
						type: 'string'
					},
					first_name: {
						type: 'string'
					},
					last_name: {
						type: 'string'
					},
					active_sstn_logging_style: {
						type: 'string'
					},
					user_role: {
						type: 'string'
					},
					email_address: {
						type: 'string'
					}
				}
			}
		},
		[CentralDatabaseKeys.fusionEntities]: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					entity_name: {
						type: 'string'
					},
					entity_title: {
						type: 'string'
					},
					primary_key: {
						type: 'array'
					}
				}
			}
		},
		[CentralDatabaseKeys.importedUnix]: {
			type: 'number'
		},
		[CentralDatabaseKeys.archived]: {
			type: 'boolean'
		},
		[CentralDatabaseKeys.pendingDelete]: {
			type: 'boolean'
		},
		[CentralDatabaseKeys.importedFromFile]: {
			type: 'boolean'
		},
		[CentralDatabaseKeys.apiConnectionId]: {
			type: ['string', 'null']
		}
	},
	type: 'object',
	description: ''
};
